import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../authStore";


export const authGuard: CanActivateFn = (route, state) => {
    const auth = inject(AuthStore);
    if (auth.loggedIn()) {
        return true;
    }
    
    return inject(Router).createUrlTree(['/login']);
};
